import React from 'react';
import { Box, Typography } from "@mui/material"
import { textColor } from "../../utils/commonstyle";
import moment from "moment";

const typographyStyles = {
  fontSize: "14px",
  // height: 370,
  width: "100%",
  overflowY: "auto",
  paddingRight: 1,
  color: textColor.fontColor,
};

export const remoteBidding = () => {
  return (
    <Box sx={typographyStyles} overflow="auto" className="scroll-container">
      <Typography component="div" whiteSpace="wrap">
        This Master Remote Bidding Agreement (this "Agreement"), effective
        as of {moment().format("MMM DD, yyyy")} (the "Effective Date"),
        is by and between Xome Inc., a Delaware corporation ("Xome"), and
        the Bidder identified above.
      </Typography>
      <Box component="ol">
        <li>
          <Typography component="div">
            <Box component="span" fontSize={16}>ENGAGEMENT:</Box> From time to time, Bidder
            may request that Xome recognize one or more bids, either
            through proxy, mobile app or online (each, a "Remote Bid"), at
            certain live auctions of real estate properties (each, a
            "Property") in accordance with the terms and conditions set
            forth in this Agreement.
          </Typography>
        </li>
        <li>
          <Typography component="div">
            <Box component="span" fontSize={16}>DEPOSIT OF FUNDS:</Box>
          </Typography>
          <Box component="ol">
            <li>
              <Typography component="div">
                Prior to submitting a Remote Bid, Bidder must establish an
                account with an escrow agent identified by Xome (the
                "Escrow Agent") by completing and executing the Bidder
                Agreement, attached hereto. The Escrow Agent will hold and
                disburse the funds deposited by Bidder as set forth in the
                Bidder Agreement.
              </Typography>
            </li>
            <li>
              <Typography component="div">
                Remote Bids will only be placed up to the amount of funds
                held by the Escrow Agent on Bidder's behalf. To ensure all
                Remote Bids are entered appropriately, Bidder should
                ensure that the Escrow Agent receives the required funds
                no later than 4:00 PM Central Time on the day that is one
                (1) business day prior to the auction.
              </Typography>
            </li>
            <li>
              <Typography component="div">
                Bidder must use a wire transfer to deposit funds with
                Escrow Agent. Bidder shall be responsible for any fees and
                costs charged by its financial institution in connection
                with depositing funds with the Escrow Agent.
              </Typography>
            </li>
          </Box>
        </li>
        <li>
          <Typography component="div">
            <Box component="span" fontSize={16}>REMOTE BIDDING REQUEST:</Box>
          </Typography>
          <Box component="ol">
            <li>
              <Typography component="div">
                By submitting a Remote Bid, Bidder places and requests
                that Xome accept successive bids in an amount that is one
                bidding increment above the then-current bid up to the
                amount of the maximum bid designated by Bidder. Bids will
                be placed in $1,000 increments, or up to the next $1,000
                if the opening bid or live bid is not in $1,000
                increments. BIDDER UNDERSTANDS THAT XOME IS NOT
                RESPONSIBLE FOR (A) FAILING TO ENTER OR ACCEPT BIDS, (B)
                ANY ERRORS RELATING TO THE ENTRY OR ACCEPTANCE OF A BID,
                OR (C) OMISSIONS OR LATE ARRIVING BIDS.
              </Typography>
            </li>
            <li>
              <Typography component="div">
                Bidder understands and acknowledges that any bid submitted
                pursuant to this Agreement constitutes an irrevocable and
                binding obligation of Bidder to purchase the Property for
                a final winning bid equal to or less than the maximum bid
                specified by Bidder. After submission to Xome, a Remote
                Bid cannot be revoked or reduced by Bidder unless
                otherwise agreed upon by Xome in writing. Xome may, in its
                sole discretion, accept, reject, or cancel any Remote Bid
                at any time.
              </Typography>
            </li>
            <li>
              <Typography component="div">
                Xome may modify or reject a Remote Bid for any Property if
                Xome cannot verify that the Escrow Agent holds sufficient
                funds to pay the winning bid amount on Bidder's behalf.
                Remote Bids will be fulfilled in the order which the
                Properties are brought to auction, which may be different
                than the scheduled sale time for each Property.
              </Typography>
            </li>
            <li>
              <Typography component="div">
                By submitting a Remote Bid, Bidder represents and warrants
                that (i) Bidder has read, accepted, and agreed to all
                applicable terms and conditions relating to the auction,
                (ii) Bidder has completed all necessary registration
                requirements for the auction, and (iii) Bidder has
                completed its independent due diligence regarding the
                Property.
              </Typography>
            </li>
          </Box>
        </li>
        <li>
          <Typography component="div">
            <Box component="span" fontSize={16}>WINNING BIDS:</Box>
          </Typography>
          <Box component="ol">
            <li>
              <Typography component="div">
                In the event Bidder is the winning bidder of a property,
                Xome shall notify Bidder of the winning bid amount and
                Escrow Agent will tender the winning bid amount on
                Bidder's behalf to the foreclosure attorney/trustee, local
                municipality, or to another appropriate party based on
                state or local requirements. Bidder shall be responsible
                for delivering any additional required payments to the
                appropriate party, if applicable. Bidder shall be
                responsible for any additional obligations required of a
                winning bidder at such sale, including the recording of
                any conveyance documents.
              </Typography>
            </li>
          </Box>
        </li>
        <li>
          <Typography component="div">
            <Box component="span" fontSize={16}>BINDING CONTRACT:</Box> Bidder understands
            and agrees that by submitting a Remote Bid for any Property,
            Bidder is committing to purchase such Property and pay the
            amount of the winning bid and any other applicable fees and
            taxes.
          </Typography>
        </li>
        <li>
          <Typography component="div">
            <Box component="span" fontSize={16}>AVAILABILITY:</Box> Remote bidding will
            only be available for certain Properties as determined by
            Xome. Bidder acknowledges and understands that Xome is
            providing the ability to Remote Bid as a convenience for
            Bidder and that Xome shall not be responsible for failing to
            accept bids or for errors relating to the entry or acceptance
            of bids for any reason, including but not limited to any
            computer, network, or other technology related errors.
          </Typography>
        </li>
        <li>
          <Typography component="div">
            <Box component="span" fontSize={16}>TERM; TERMINATION:</Box> The Agreement will
            commence on the Effective Date and, unless terminated earlier
            in accordance with the terms of the Agreement, will remain in
            force and effect until terminated (the "Term"). Xome may
            terminate this Agreement and any Remote Bid for any reason
            immediately upon notice to Bidder. Bidder may terminate this
            Agreement for any reason by providing Xome with at least
            thirty (30) days prior written notice of its intent to
            terminate. Upon receipt of such notice of termination by
            either party, the Agreement shall terminate upon the date
            provided in such notice unless any Remote Bid is still
            pending, in which case the Agreement shall not terminate until
            such Remote Bid has been cancelled or fulfilled.
          </Typography>
        </li>
        <li>
          <Typography component="div">
            <Box component="span" fontSize={16}>INDEMNITIES:</Box> Bidder shall indemnify, defend, and hold harmless Xome, each person or entity deemed to control or to be controlled by Xome, and their respective affiliates, partners, members, shareholders, managers, directors, officers, employees, agents, and representatives against and from any and all losses, liabilities, and damages (including without limitation reasonable attorneys' fees) arising in connection with any action, claim, controversy, proceeding, or investigation relating to this Agreement or Bidder's failure to consummate the purchase of the Property in accordance with a Remote Bid.
          </Typography>
        </li>
        <li>
          <Typography component="div">
            <Box component="span" fontSize={16}>NOTICES:</Box> Any notice given under the
            Agreement must be in writing and be delivered to the
            applicable address listed in the Agreement by (a) personal
            delivery, (b) certified United States mail, return receipt
            requested, (c) a nationally recognized overnight courier
            service, or (d) electronic mail. All notices are deemed given
            upon receipt or upon the date receipt is refused by the
            recipient, except that notices delivered by electronic mail
            are not deemed given until acknowledged by the recipient.
          </Typography>
        </li>
        <li>
          <Typography component="div">
            <Box component="span" fontSize={16}>ANNOUNCEMENTS:</Box> Only Xome may issue
            press releases or announcements regarding the Agreement or any
            transaction provided, however, that such press release and/or
            announcement in no way places either party in a false light,
            disparages, or in any manner reflects negatively upon either
            party to the Agreement.
          </Typography>
        </li>
        <li>
          <Typography component="div">
            <Box component="span" fontSize={16}>AUTHORITY:</Box> Each party represents and
            warrants that it is duly authorized to enter into the
            Agreement and perform its obligations hereunder. Each natural
            person signing the Agreement on behalf of an entity represents
            and warrants that he/she has the requisite authority to so
            bind the entity.
          </Typography>
        </li>
        <li>
          <Typography component="div">
            <Box component="span" fontSize={16}>INDEPENDENT CONTRACTORS:</Box> Nothing
            herein shall be construed as creating an employer/employee,
            partnership, or agency relationship between the parties. Xome
            is acting as the auctioneer and does not represent the Bidder.
          </Typography>
        </li>
        <li>
          <Typography component="div">
            <Box component="span" fontSize={16}>AMENDMENTS:</Box> No modifications to the
            Agreement will be effective unless made in writing and signed
            by all parties to the Agreement.
          </Typography>
        </li>
        <li>
          <Typography component="div">
            <Box component="span" fontSize={16}>ASSIGNMENT; SUCCESSORS:</Box> Bidder shall
            not assign its rights or obligations under the Agreement, in
            whole or in part, without the prior written consent of Xome
            (and any such attempted assignment or delegation shall be
            void); provided, however, no such assignment shall relieve the
            assignor of its obligations hereunder. Except as described in
            the preceding sentence, the Agreement shall be binding upon,
            inure to the benefit of, and be enforceable by and against the
            respective successors and assigns of the parties to the
            Agreement.
          </Typography>
        </li>
        <li>
          <Typography component="div">
            <Box component="span" fontSize={16}>LIMITED LIABILITY:</Box> Bidder
            acknowledges that Bidder will not have any claims whatsoever
            against Xome, any party related to the sale or any of their
            agents, representatives, and employees and Bidder hereby
            expressly waives any such claims.
          </Typography>
        </li>
        <li>
          <Typography component="div">
            <Box component="span" fontSize={16}>WAIVER OF RIGHT FOR JURY TRIAL:</Box> TO
            THE EXTENT PERMITTED BY LAW, EACH PARTY HERETO, AFTER
            CONSULTING (OR HAVING HAD THE OPPORTUNITY TO CONSULT) WITH
            COUNSEL OF ITS, HIS, OR HER CHOICE, KNOWINGLY, VOLUNTARILY,
            AND IRREVOCABLY WAIVES ALL RIGHT TO TRIAL BY JURY IN ANY
            ACTION, PROCEEDING, CLAIM, OR COUNTERCLAIM (WHETHER BASED ON
            CONTRACT, TORT, OR OTHERWISE) ARISING OUT OF OR RELATING TO
            THE AGREEMENT.
          </Typography>
        </li>
        <li>
          <Typography component="div">
            <Box component="span" fontSize={16}>GOVERNING LAW:</Box> With respect to each
            Property, the Agreement shall be governed, construed, and
            enforced by the law of the jurisdiction where the auction is
            held, without regard to the conflicts of law principles of
            such state. To the extent permitted by law, any legal action
            or proceeding arising under the Agreement shall be brought
            exclusively in the federal or state courts located in Denton
            County, Texas, and the parties hereby irrevocably consent to
            the personal jurisdiction and venue therein.
          </Typography>
        </li>
        <li>
          <Typography component="div">
            <Box component="span" fontSize={16}>FURTHER ASSURANCES:</Box> The parties
            hereby agree to execute such other documents and to take such
            other actions as may reasonably be necessary to further the
            purposes of the Agreement.
          </Typography>
        </li>
        <li>
          <Typography component="div">
            <Box component="span" fontSize={16}>SEVERABILITY:</Box> If any portion of the
            Agreement is judicially determined to be invalid or
            unenforceable, that portion shall be deemed severable from the
            Agreement and the remainder of the Agreement shall remain in
            full force and effect and shall be construed to fulfill the
            intention of the parties.
          </Typography>
        </li>
        <li>
          <Typography component="div">
            <Box component="span" fontSize={16}>ATTORNEYS' FEES:</Box> If any party must
            institute legal action to enforce the Agreement, or for breach
            of the Agreement, the prevailing party, as determined by the
            court in such action, shall be entitled to receive actual
            reasonable attorneys' fees and costs. The prevailing party is
            the party entitled to recover its costs of suit, regardless of
            whether such suit proceeds to final judgment.
          </Typography>
        </li>
        <li>
          <Typography component="div">
            <Box component="span" fontSize={16}>NO GENERAL WAIVER:</Box> The failure of any
            party to enforce any provision or resort to any remedy under
            the Agreement shall in no way affect the right of that party
            to later enforce any provision or resort to any remedy under
            the Agreement. Waiver by any party of a breach shall not be
            deemed to be a waiver of any subsequent breach.
          </Typography>
        </li>
        <li>
          <Typography component="div">
            <Box component="span" fontSize={16}>COUNTERPARTS; ELECTRONIC SIGNATURES:</Box>
            The Agreement may be executed in multiple counterparts, and
            all counterparts shall constitute one agreement binding upon
            all parties, whether or not all parties are signatories to the
            original or the same counterpart. Signatures scanned and
            transmitted electronically and electronic signatures shall be
            deemed original signatures for purposes of the Agreement, and
            shall have the same legal effect as original signatures.
          </Typography>
        </li>
        <li>
          <Typography component="div">
            <Box component="span" fontSize={16}>PROHIBITED PERSONS AND TRANSACTIONS:</Box>{" "}
            Bidder represents and warrants that neither it, nor any of its
            affiliates, nor any of their members, directors or other
            equity owners (excluding holders of publicly traded shares),
            and none of their principal officers and employees: (i) is
            listed as a "specifically designated national and blocked
            person" on the most current list published by the U.S.
            Treasury Department Office of Foreign Asset Control ("OFAC");
            (ii) is a person or entity with whom U.S. persons or entities
            are restricted from doing business under OFAC regulations or
            any other statute or executive order (including the September
            24, 2001 "Executive Order Blocking Property and Prohibiting
            Transactions with Persons Who Commit, Threaten to Commit, or
            Support Terrorism"); and (iii) is engaged in prohibited
            dealings or transactions with any such persons or entities.
          </Typography>
        </li>
      </Box>
    </Box>
  );
}

export const bidderAgreement = () => {
  return <Typography
    sx={typographyStyles}
    overflow={"scroll"}
    className="scroll-container"
    whiteSpace={"wrap"}
  >
    THIS BIDDER AGREEMENT ("Bidder Agreement") is entered by and
    between Bidder (as identified below) and Xome Inc., a Delaware
    corporation (“Xome”); and as escrow agent hereunder ("Escrow
    Agent") (collectively, the "Parties") as of the date it has been
    signed by all Parties.
    <Typography
      sx={{ textAlign: "center", fontWeight: 600, my: 1 }}
      color={"#3B3B3B"}
    >
      BACKGROUND
    </Typography>
    A. Bidder shall be bidding at foreclosure auctions and/or
    purchasing foreclosed upon real estate for the purchase of real
    estate subject to the terms and conditions of such auctions and
    has entered into a Master Remote Bidding Agreement (the "Master
    Agreement"). Bidder is depositing funds in an escrow account to be
    held by Escrow Agent for the purposes of purchasing real property
    as set forth above (the "Funds"). B. Escrow Agent has agreed to
    accept, hold, and disburse the funds deposited with it in
    accordance with the terms of this Bidder Agreement.
    <Typography
      sx={{ textAlign: "center", fontWeight: 600, my: 1 }}
      color={"#3B3B3B"}
    >
      AGREEMENT
    </Typography>
    For good and valuable consideration, the receipt and sufficiency
    of which are hereby acknowledged, the parties hereto, for
    themselves, their successors and assigns, hereby agree as follows:
  </Typography>
}

export const bidderAgreementData = () => (
  <ol>
    <li>
      Appointment of and Acceptance by Escrow Agent. Bidder and Xome
      hereby appoint Escrow Agent to serve as escrow agent and Escrow
      Agent accepts such appointment. Escrow Agent agrees to receive,
      hold, and disburse the Escrow Funds in accordance with this
      Bidder Agreement.
    </li>
    <li>
      Deposit of Funds. Bidder shall deposit funds with the Escrow
      Agent via wire transfer in accordance with the Deposit
      Instructions attached hereto as Exhibit A ("Deposit
      Instructions")
    </li>
    <li>
      Disbursements of Escrow Funds. Escrow Agent shall disburse
      Escrow Funds only under the following circumstances:
      <ol>
        <li>
          upon receipt of a winning bidder notification sent to the
          Escrow Agent by Xome indicating that the Bidder is the
          winning bidder ("Winning Bidder Notification"). The Winning
          Bidder Notification shall indicate the winning bid amount,
          the account to which the funds shall be wired, and the
          payment amount to be tendered immediately by Escrow Agent on
          behalf of Bidder ("Required Payment"). Both Bidder and Xome
          hereby irrevocably authorize the Escrow Agent to immediately
          wire the Required Payment as directed by Xome upon receipt
          of the Winning Bidder Notification. No further authorization
          or direction from Xome or Bidder will be required; or
        </li>
        <li>
          upon joint written instructions mutually agreed to by both
          Bidder and Xome or as set forth in the Master Agreement
          ("Joint Written Direction"). Xome or Escrow Agent shall not
          accept Joint Written Direction requesting the funds to be
          sent to any third party.
        </li>
      </ol>
    </li>
    <li>
      Binding Effect: Successors. This Bidder Agreement shall be
      binding upon the respective parties hereto and their heirs,
      executors, successors or assigns. If the Escrow Agent
      consolidates, merges or converts into, or transfers all or
      substantially all of its corporate trust business (including the
      escrow contemplated by this Bidder Agreement) to another
      corporation, the successor or transferee corporation without any
      further act shall be the successor Escrow Agent.
    </li>
    <li>
      Liability of Escrow Agent. The Escrow Agent undertakes to
      perform only such duties as are expressly set forth herein and
      no duties shall be implied. The Escrow Agent shall not be liable
      for any action taken or omitted by it in good faith except to
      the extent that a court of competent jurisdiction determines
      that the Escrow Agent's gross negligence or willful misconduct
      was a cause of any loss to the Bidder or Xome. Escrow Agent may
      rely upon any notice, instruction, request or other instrument,
      not only as to its due execution, validity and effectiveness,
      but also as to the truth and accuracy of any information
      contained therein, which Escrow Agent reasonably believes to be
      genuine and to have been signed or presented by the person or
      parties purporting to sign the same. In no event shall Escrow
      Agent be liable for incidental, indirect, special, consequential
      or punitive damages or penalties (including, but not limited to
      lost profits), even if the Escrow Agent has been advised of the
      likelihood of such damages or penalty and regardless of the form
      of action. Escrow Agent shall not be responsible for delays or
      failures in performance resulting from acts beyond its control,
      including without limitation acts of God, strikes, lockouts,
      riots, acts of war or terror, epidemics, governmental
      regulations, fire, communication line failures, computer
      viruses, power failures, earthquakes or other disasters. Bidder
      and Xome agree to perform or procure the performance of all
      further acts and things, and execute and deliver such further
      documents, as may be required by law or as Escrow Agent may
      reasonably request in connection with its duties hereunder.{" "}
    </li><li>
      The Escrow Agent is authorized, in its sole discretion, to
      comply with final orders, writ, judgment or decree issued or
      process entered by any court with respect to the Escrow Funds,
      without determination by the Escrow Agent of such court's
      jurisdiction in the matter.
    </li>
    <li>
      Indemnification of Escrow Agent. Unless the Escrow Agent is
      liable for gross negligence or misconduct with regard to its
      duties hereunder. Bidder and Xome hereby agrees to indemnify the
      Escrow Agent and each director, officer, employee, attorney,
      agent and affiliate of Escrow Agent (collectively, the
      "Indemnified Parties") and hold it harmless from any and all
      claims, liabilities, losses, actions, suits or proceedings at
      law or in equity, or any other expense, fees or charges of any
      character or nature which it may incur or with which it may be
      threatened by reason of its actions under this Agreement; and in
      connection therewith, to indemnify the Escrow Agent against any
      and all expenses, including reasonable attorneys' fees and the
      cost of defending any action, suit or proceeding or resisting
      any claim. In the event the Escrow Agent is found to be liable
      for gross negligence or misconduct. Escrow Agent shall reimburse
      or hold harmless Xome and Bidder for any costs incurred in
      defense of Escrow Agent. Moreover, in such an event. Escrow
      Agent agrees to pay all costs, including reasonable attorney's
      fees, incurred by Xome and Bidder arising out of Escrow Agent's
      gross negligence or misconduct. The Escrow Agent shall not have
      any lien or claim on any property deposited hereunder, for
      reasonable attorneys' fees, court costs, for any suit,
      interpleader or otherwise, or any other liabilities, expenses,
      fees or charges of any character. Each Indemnified Party shall,
      in its sole discretion, have the right to select and employ
      separate counsel with respect to any action or claim brought or
      asserted against it, and the reasonable fees of such counsel
      shall be payable equally by Bidder and Xome. although Escrow
      Agent may make demand upon Bidder or Xome jointly and severally.
      In such an event, the party paying for Escrow Agent's defense
      may make an immediate demand for setoff or indemnity as against
      the other party. Notwithstanding the foregoing, in the event an
      action is brought by either party, for which Escrow Agent seeks
      defense under this section, Xome in its sole and absolute
      discretion may select and retain counsel for Escrow Agent. The
      obligations of Bidder and Xome under this Section 9 shall
      survive any termination of this Bidder Agreement and the
      resignation or removal of Escrow Agent. The parties agree that
      neither the payment by Bidder or Xome of any claim by Escrow
      Agent for indemnification hereunder nor the disbursement of any
      amounts to Escrow Agent from the Escrow Funds in respect of a
      claim by Escrow Agent for indemnification shall impair, limit,
      modify, or affect, as between Bidder and Xome. the respective
      rights and obligations of Bidder and Xome under the Underlying
      Agreements.
    </li>
    <li>
      Fees. Bidder shall be charged a $499 technology fee as a fee for
      the services provided by Xome pursuant to this Agreement. Escrow
      Agent is authorized to deduct the technology fee from the amount
      held on Bidder's behalf immediately upon confirmation of a
      winning bid.
    </li>
    <li>
      Representations and Warranties. Bidder and Xome each
      respectively make the following representations and warranties
      to Escrow Agent:
      <ol>
        <li>
          it has full power and authority to execute and deliver this
          Bidder Agreement and to perform its obligations hereunder;
          and this Bidder Agreement has been duly approved by all
          necessary action and constitutes its valid and binding
          agreement enforceable in accordance with its terms.
        </li>
      </ol>
    </li>
    <li>
      Identifying information. Any non-individual person such as a
      business entity, a charity, a trust, or other legal entity may
      be required to provide the Escrow Agent documentation to verify
      its formation and existence as a legal entity. The parties
      acknowledge that a portion of of such identifying information
      set forth herein is being requested by the Escrow Agent in
      connection with the USA Patriot Act, Pub.L. 107-56 (the "Act"),
      and each agrees to provide any additional information requested
      by the Escrow Agent in connection with the Act or any other
      legislation or regulation to which Escrow Agent is subject, in a
      timely manner.
    </li>
    <li>
      Consent to Jurisdiction and Venue. In the event that any party
      hereto commences a lawsuit or other proceeding relating to or
      arising from this Bidder Agreement, the parties hereto agree to
      the personal jurisdiction by and venue in the state and federal
      courts in the State of Ohio and waive any objection to such
      jurisdiction or venue. The parties hereto consent to and agree
      to submit to the jurisdiction of any of the courts specified
      herein and agree to accept service of process to vest personal
      jurisdiction over them in any of these courts.
    </li>
    <li>
      Notices. All notices and other communications hereunder shall be
      in writing and shall be delivered (i) by personal delivery, or
      (ii) by national overnight courier service, or (iii) by
      certified or registered mail, return receipt requested, or (iv)
      via email by way of a PDF attachment thereto of an executed
      document. Notice shall be effective upon receipt except for
      notice via email, which shall be effective only when the
      recipient, by return email or notice delivered by other method
      provided for in this Section 12, acknowledges having received
      that email (with an automatic "read receipt" or similar notice
      not constituting an acknowledgement of an email receipt for
      purposes of this Section 12). Such notices shall be sent to the
      applicable party or parties at the address specified in Section
      1 or to such other address as each party may designate for
      itself by like notice and unless otherwise provided herein shall
      be deemed to have been given on the date received.
    </li>
    <li>
      Amendment. Waiver and Assignment. None of the terms or
      conditions of this Bidder Agreement may be changed, waived,
      modified, discharged, terminated or varied in any manner
      whatsoever unless in writing duly signed by each party to this
      Bidder Agreement.
    </li>
    <li>
      Severability. To the extent any provision of this Bidder
      Agreement is prohibited by or invalid under applicable law, such
      provision shall be ineffective to the extent of such prohibition
      or invalidity, without invalidating the remainder of such
      provision or the remaining provisions of this Bidder Agreement.
    </li>
    <li>
      Governing Law. This Bidder Agreement shall be construed and
      interpreted in accordance with the internal laws of the State of
      Texas without giving effect to the conflict of laws principles
      thereof.
    </li>
    <li>
      Entire Agreement, No Third-Party Beneficiaries. This Bidder
      Agreement constitutes the entire agreement between the parties
      with respect to the Escrow Funds. Nothing in this Bidder
      Agreement, express or implied, is intended to or shall confer
      upon any other person any right, benefit or remedy of any nature
      whatsoever under or by reason of this Bidder Agreement.
    </li>
    <li>
      Execution in Counterparts, Facsimiles and Electronic Signatures.
      This Bidder Agreement and any Joint Written Direction may be
      executed in two or more counterparts, which when so executed
      shall constitute one and the same agreement or direction. The
      delivery of copies of this Bidder Agreement and any Joint
      Written Instruction and their respective signature pages by PDF
      or electronic transmission shall constitute effective execution
      and delivery as to the parties and may be used in lieu of
      originals for all purposes.
    </li>
    <li>
      Tax Reporting. Escrow Agent shall have no responsibility for the
      tax consequences of this Agreement and Bidder and Xome shall
      consult with independent counsel concerning any and all tax
      matters. Bidder and Xome shall provide Escrow Agent Form W-9
      together with any other documentation and information requested
      by Escrow Agent. Bidder and Xome shall provide any additional
      tax documentation that may be required by Escrow Agent from time
      to time.
    </li>
    <li>
      WAIVER OF TRIAL BY JURY. EACH PARTY TO THIS AGREEMENT HEREBY
      WAIVES ANY RIGHT THAT IT MAY HAVE TO A TRIAL BY JURY ON ANY
      CLAIM, COUNTERCLAIM, SETOFF, DEMAND, ACTION OR CAUSE OF ACTION (
      I ) ARISING OUT OF OR IN ANY WAY RELATED TO THIS AGREEMENT OR
      (2) IN ANY WAY IN CONNECTION WITH OR PERTAINING OR RELATED TO OR
      INCIDENTAL TO ANY DEALINGS OF THE PARTIES TO THIS AGREEMENT OR
      IN CONNECTION WITH THIS AGREEMENT OR THE EXERCISE OF ANY SUCH
      PARTY'S RIGHTS AND REMEDIES UNDER THIS AGREEMENT OR THE CONDUCT
      OR THE RELATIONSHIP OF THE PARTIES TO THIS AGREEMENT, IN ALL OF
      THE FOREGOING CASES WHETHER NOW EXISTING OR HEREAFTER ARISING
      AND WHETHER IN CONTRACT, TORT OR OTHERWISE. EACH OF THE PARTIES
      HERETO HEREBY FURTHER ACKNOWLEDGES AND AGREES THAT EACH HAS
      REVIEWED OR HAD THE OPPORTUNITY TO REVIEW THIS WAIVER WITH ITS
      RESPECTIVE LEGAL COUNSEL, AND THAT IT KNOWINGLY AND VOLUNTARILY
      WAIVES ITS JURY TRIAL RIGHTS FOLLOWING CONSULTATION WITH SUCH
      LEGAL COUNSEL. IN THE EVENT OF LITIGATION, THIS AGREEMENT MAY BE
      FILED AS A CONSENT BY ALL PARTIES TO A TRIAL BY THE COURT.
    </li>
  </ol>
)